module.exports = __webpack_public_path__ + "static/media/02-search.618efa8c.png";